import * as Sentry from '@sentry/browser';
import { User } from '@sentry/browser';
import { UserInfo } from '@/declarations/auth';

/* eslint-disable no-param-reassign */
const mutations = {
  set(state, { type, value }) {
    state[type] = value;
  },
  set_user(state, obj) {
    state.user[obj.key] = obj.value;
  },
};

const actions = {
  setSentryUser(context) {
    const userData = context.state.user;
    let user: User | null = null;
    if (userData?.id) {
      user = {
        id: String(userData.id),
        username: userData.login,
        email: userData.email,
      };
    }
    console.debug('Sentry user:', user);
    Sentry.setUser(user);
  },
  setUser(context, userData: UserInfo) {
    context.commit('set', { type: 'user', value: userData });
    context.dispatch('setSentryUser');
  },
  updateUser({ commit }, userData) {
    Object.keys(userData).forEach((key) => {
      if (userData[key] !== null || userData[key] !== 'undefined') {
        commit('set_user', { key, value: userData[key] });
      }
    });
  },
  removeUser({ dispatch }) {
    dispatch('setUser', {});
  },
};

const getters = {
  user: (state) => state.user,
  isEmptyUser: (state) => Object.keys(state.user).length === 0,
};

const state = {
  user: {},
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
